class Functions {
    constructor(_request) {
        this.request = _request;
    }

    list() {
        return this.request.fetch({ method: "GET", endpoint: "functions" });
    }

    create(_data) {
        return this.request.fetch({
            method: "POST",
            endpoint: "functions",
            params: _data
        });
    }

    upsert(_data) {
        return this.create({..._data, upsert: true});
    }
    
}

export default Functions;
